import React from "react";
import uniqueId from "lodash/uniqueId";
import { Button, styled } from "@mui/material";
import PropTypes from "prop-types";
import { CommonButtonStyles } from "../../../../components/Buttons/BackLink";

const StyledAddButton = styled(Button)(({ theme }) => ({
  ...CommonButtonStyles({ theme }),
  textTransform: "none",
  fontSize: "14px !important",
  fontWeight: "500px",
  borderRadius: "100px",
  border: "1px solid #3B3A3A",
  color: "#3B3A3A",
  padding: "12px 30px",
  lineHeight: "20px",
  textDecoration: "none",
  "&.Mui-disabled": {
    color: "#B0B0B0",
    backgroundColor: "#F5F5F5",
    border: "1px solid #D0D0D0",
    "& .arrowIcon": {
      fill: "#B0B0B0",
      "& path": {
        fill: "#B0B0B0"
      }
    }
  }
}));

export const ArrayAddButton = ({
  arrayHelpers,
  dataArray,
  addedItem,
  limit,
  requiredFields,
  ...props
}) => {
  const checkIsAddButtonDisabled = () => {
    if (!dataArray.length) {
      return false;
    }
    const lastAddedItem = dataArray[dataArray.length - 1];
    return dataArray.length === limit || requiredFields.some(item => lastAddedItem[item] === "");
  };
  return (
    <StyledAddButton
      onClick={() => arrayHelpers.insert(dataArray.length, { ...addedItem, id: uniqueId() })}
      disabled={checkIsAddButtonDisabled()}
      {...props}
    >
      {" "}
      <span>{props.title}</span>
    </StyledAddButton>
  );
};

ArrayAddButton.propTypes = {
  arrayHelpers: PropTypes.shape({
    insert: PropTypes.func.isRequired
  }).isRequired,
  dataArray: PropTypes.array.isRequired,
  addedItem: PropTypes.object.isRequired,
  limit: PropTypes.number,
  requiredFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string
};
